import React from 'react';
import { CheckCircle2, XCircle, Zap } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function UpsellSection() {
  return <section className="bg-gray-50 py-20 px-4" data-id="element-414">
      <div className="max-w-4xl mx-auto" data-id="element-415">
        <div className="text-center mb-10" data-id="element-416">
          <span className="text-neon font-bold text-sm tracking-widest uppercase bg-black px-4 py-1 rounded-full" data-id="element-417">
            — MEJORA TU PEDIDO (SOLO UNA VEZ) —
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-black text-center leading-tight mb-12 font-montserrat" data-id="element-418">
          "Añade el Pack Acelerador Pro y Empieza a Ganar 3 Veces más Rápido por
          Solo 7€ más"
        </h2>

        <div className="text-lg text-gray-800 space-y-6 mb-16 text-center max-w-3xl mx-auto" data-id="element-419">
          <p data-id="element-420">
            El 90% de los creadores que no llegan a los primeros ingresos no
            fallan por falta de ganas.
          </p>
          <p data-id="element-421">
            Fallan porque pierden semanas escribiendo guiones desde cero,
            buscando la forma correcta de hablar con marcas y paralizados por el
            miedo a Hacienda.
          </p>
          <p className="font-bold text-xl text-black bg-yellow-100 p-4 rounded-lg border border-yellow-300" data-id="element-422">
            El Pack Acelerador Pro elimina esos 3 obstáculos de golpe:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-423">
          <div className="bg-gray-900 rounded-2xl border-2 border-neon p-6 shadow-neon" data-id="element-424">
            <h3 className="text-xl font-black text-neon mb-3 flex items-center gap-2" data-id="element-425">
              <Zap className="w-5 h-5" data-id="element-426" /> BLOQUE 1: LABORATORIO DE GUIONES
            </h3>
            <p className="text-gray-300" data-id="element-427">
              10 guiones completos "rellena los huecos" para los 5 nichos más
              rentables. No pienses. Solo personaliza y graba.
            </p>
          </div>

          <div className="bg-gray-900 rounded-2xl border-2 border-neon p-6 shadow-neon" data-id="element-428">
            <h3 className="text-xl font-black text-neon mb-3 flex items-center gap-2" data-id="element-429">
              <Zap className="w-5 h-5" data-id="element-430" /> BLOQUE 2: KIT DE PROSPECCIÓN DIRECTA
            </h3>
            <p className="text-gray-300" data-id="element-431">
              15 mensajes y scripts de conversión listos para copiar y pegar en
              Instagram, LinkedIn y TikTok.
            </p>
          </div>

          <div className="bg-gray-900 rounded-2xl border-2 border-neon p-6 shadow-neon" data-id="element-432">
            <h3 className="text-xl font-black text-neon mb-3 flex items-center gap-2" data-id="element-433">
              <Zap className="w-5 h-5" data-id="element-434" /> BLOQUE 3: BLINDAJE LEGAL Y FISCAL
              ESPAÑA
            </h3>
            <p className="text-gray-300" data-id="element-435">
              Todo lo que necesitas saber sobre autónomos, IVA, IRPF y cómo
              cobrar legalmente desde el primer euro.
            </p>
          </div>

          <div className="bg-gray-900 rounded-2xl border-2 border-neon p-6 shadow-neon" data-id="element-436">
            <h3 className="text-xl font-black text-neon mb-3 flex items-center gap-2" data-id="element-437">
              <Zap className="w-5 h-5" data-id="element-438" /> BLOQUE 4: MEDIA KIT PRO
            </h3>
            <p className="text-gray-300" data-id="element-439">
              Estructura visual y textos exactos para que tu presentación
              parezca de una agencia de 5.000€/mes.
            </p>
          </div>
        </div>

        <div className="bg-black rounded-2xl overflow-hidden mb-16 shadow-2xl" data-id="element-440">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-441">
            <div className="p-8 border-b md:border-b-0 md:border-r border-gray-800" data-id="element-442">
              <h4 className="text-xl font-bold text-gray-400 text-center mb-8 uppercase tracking-wider" data-id="element-443">
                Sin Pack Acelerador Pro
              </h4>
              <ul className="space-y-6" data-id="element-444">
                <li className="flex items-start gap-3 text-gray-400" data-id="element-445">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0" data-id="element-446" />
                  <span data-id="element-447">Escribes guiones desde cero (3-4h por guion)</span>
                </li>
                <li className="flex items-start gap-3 text-gray-400" data-id="element-448">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0" data-id="element-449" />
                  <span data-id="element-450">Inventas mensajes de prospección</span>
                </li>
                <li className="flex items-start gap-3 text-gray-400" data-id="element-451">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0" data-id="element-452" />
                  <span data-id="element-453">Miedo a Hacienda te paraliza</span>
                </li>
                <li className="flex items-start gap-3 text-gray-400" data-id="element-454">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0" data-id="element-455" />
                  <span data-id="element-456">Media Kit amateur</span>
                </li>
                <li className="flex items-start gap-3 text-gray-400" data-id="element-457">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0" data-id="element-458" />
                  <span data-id="element-459">Time-to-Money: 30-60 días</span>
                </li>
              </ul>
            </div>

            <div className="p-8 bg-gray-900 relative" data-id="element-460">
              <div className="absolute top-0 left-0 w-full h-1 bg-neon" data-id="element-461"></div>
              <h4 className="text-xl font-bold text-neon text-center mb-8 uppercase tracking-wider" data-id="element-462">
                Con Pack Acelerador Pro
              </h4>
              <ul className="space-y-6" data-id="element-463">
                <li className="flex items-start gap-3 text-white" data-id="element-464">
                  <CheckCircle2 className="w-6 h-6 text-neon shrink-0" data-id="element-465" />
                  <span className="font-bold" data-id="element-466">10 guiones listos en 10 min</span>
                </li>
                <li className="flex items-start gap-3 text-white" data-id="element-467">
                  <CheckCircle2 className="w-6 h-6 text-neon shrink-0" data-id="element-468" />
                  <span className="font-bold" data-id="element-469">
                    15 mensajes listos para copiar
                  </span>
                </li>
                <li className="flex items-start gap-3 text-white" data-id="element-470">
                  <CheckCircle2 className="w-6 h-6 text-neon shrink-0" data-id="element-471" />
                  <span className="font-bold" data-id="element-472">
                    Guía legal clara desde el día 1
                  </span>
                </li>
                <li className="flex items-start gap-3 text-white" data-id="element-473">
                  <CheckCircle2 className="w-6 h-6 text-neon shrink-0" data-id="element-474" />
                  <span className="font-bold" data-id="element-475">Media Kit Pro nivel agencia</span>
                </li>
                <li className="flex items-start gap-3 text-white" data-id="element-476">
                  <CheckCircle2 className="w-6 h-6 text-neon shrink-0" data-id="element-477" />
                  <span className="font-bold" data-id="element-478">Time-to-Money: 7-14 días</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <CTAButton data-id="element-479" />
      </div>
    </section>;
}